import React  from 'react';
import StoryPointsComponentProto from './story-points-proto';

export default function renderListInList(props) {
    return <StoryPointsComponentProto renderMode="list" {...props} />;
}